import { FC, ComponentProps, useState, useEffect } from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { Switch } from '@/_shared/components/Switch';

type Props = {
  control: Control<FieldValues>;
  name: string;
  additonalProps?: Record<string, unknown>;
} & ComponentProps<typeof Switch>;

export const WrappedToggle: FC<Props> = ({ control, name, additonalProps, ...props }) => {
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    if (props.isChecked) {
      setChecked(props.isChecked);
    }

    return () => {
      setChecked(false);
    };
  }, [props.isChecked]);

  return (
    <Controller
      control={control}
      name={name}
      rules={{ ...additonalProps }}
      render={({ field }) => (
        <Switch
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...field}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          variant='classic/small'
          onClick={e => {
            setChecked(!checked);
            field.onChange(!checked);
            if (props.onClick) {
              props.onClick(e);
            }
          }}
          isChecked={checked}
        />
      )}
    />
  );
};
